import { render, staticRenderFns } from "./nomalInputDialog.vue?vue&type=template&id=81dc01a4&scoped=true&"
import script from "./nomalInputDialog.vue?vue&type=script&lang=js&"
export * from "./nomalInputDialog.vue?vue&type=script&lang=js&"
import style0 from "./nomalInputDialog.vue?vue&type=style&index=0&id=81dc01a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dc01a4",
  null
  
)

export default component.exports